import React from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import './styles.scss';

const isNotRoot = (props) => props.location.pathname !== '/';

const Index = (props) => {
  return (
    <header className="header">
      <div className="row">
        <NavLink
          className="header__logo"
          to="/"
        />
        {/* eslint-disable-next-line */}
        {isNotRoot(props) && (
          <div className="header__tabs-container">
            <NavLink
              className="header__tab"
              activeClassName="header__tab--active"
              to="/recommend"
            >
              Рекомендация
            </NavLink>
            <NavLink
              className="header__tab"
              activeClassName="header__tab--active"
              to="/apply"
            >
              Отклик
            </NavLink>
          </div>
        )}
      </div>
    </header>
  );
};

export default withRouter(Index);
